import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import useLocale from 'js/hooks/useLocale'
import { useLocation } from 'react-router-dom'

function withSSR(WrappedComponent) {
  function WrappedPage({ initialData, match, getInitialProps, ...rest }) {
    const [data, setData] = useState(initialData)
    const [isLoading, setIsLoading] = useState(!initialData)
    const [error, setError] = useState(null)
    const { language } = useLocale()
    const location = useLocation()

    useEffect(() => {
      const params = new URLSearchParams(location.search)
      const isPreview = params.has('preview')

      if (isPreview || !initialData) {
        fetchData()
      }
    }, [location])

    const fetchData = () => {
      getInitialProps({ match: match, language })
        .then(data => {
          if (
            typeof data === 'undefined' ||
            data.length === 0 ||
            Object.entries(data).length === 0
          ) {
            setError('Not found')
            setIsLoading(false)
            return
          }
          setData(data)
          setIsLoading(false)
        })
        .catch(error => {
          setError(error)
          setIsLoading(false)
        })
    }

    return (
      <WrappedComponent
        match={match}
        {...rest}
        error={error}
        refetch={fetchData}
        data={data}
        isLoading={isLoading}
        key={location}
      />
    )
  }

  WrappedPage.propTypes = {
    initialData: PropTypes.object,
    match: PropTypes.object,
    getInitialProps: PropTypes.func.isRequired,
  }

  return WrappedPage
}

const propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
  error: PropTypes.object,
  match: PropTypes.object,
  refetch: PropTypes.func,
}

export { propTypes }
export default withSSR
